<template>
  <div class="home">
    <div>
      <img src="@/assets/logo.png" class="top_logo">
      <div class="top_logo"></div>
      <div>nav bar</div>
      <div>
        <div>登录</div>
      </div>
    </div>

    <div class="index_bn_p1">
     
      <div>
        <div>
          安全地管理、跟踪、共享文档
          控制共享文档的方方面面，即使在您点击发送后也是如此。
        </div>
        <input type="text" placeholder="请输入您的手机号"></input>
        <button>开始免费用！</button>
      </div>

    </div>

    <Div>
      
    </Div>
    


    <a href="#/login">去登录</a>

    <div class="icp_show">
      <!-- <div class="foot_logo"><img src="@/assets/foot_logo.png" ></div> -->
      <a href="https://beian.miit.gov.cn" target="_blank">京ICP备2022034630号-2</a>
    </div>

  </div>
</template>

<script>

import CommonNav from "@/components/Nav.vue";
import CommonHeader from "@/components/Header.vue";
import * as MN from '@/api/common'
export default {
  name: 'loginView',
  data(){
    return{
      u_phone: '',
      u_pass: '',
    }
  },
  components: {
		CommonNav,
		CommonHeader
	},
  methods:{

  }
}
</script>
<style scoped>
.top_logo{
  width: 120px;
}

.index_bn_p1{
  height: 300px;
  background: url('@/assets/main_pic.jpg') no-repeat;
  background-size:400px;
  background-position: 70% 50%;
}

.foot_logo{ margin-bottom: 8px; }
.foot_logo img{ width: 110px; }

.icp_show a{ text-decoration: none;color: #818181; }

.icp_show{
  /* z-index: 0;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 50px; */
  color: #818181;
  text-align: center;
  font-size: 12px;
  padding: 0 0 80px 0;
}

.home{
  /* position: fixed; */
  width: 100%;
  height: 100%;
/* animation-name: feather_3;  
  animation-duration:3s; 
  animation-iteration-count:111;
  animation-timing-function:ease-out; 
  animation-direction:alternate; 
  animation-fill-mode:forwards; */
/*  
  background-color: #EFEFEF; */
}
.wd-login{
  width: 350px;
  padding: 50px;
  /* border: 1px solid #e6e6e6; */
  background-color: #ffffff;
  opacity: 0.98;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 200px;
  position: relative;
  box-shadow: 4px 6px 48px #d4f0ff;
}
.copy_right{
  position: absolute; 
  right: 50px;
  bottom: 10px;
  color: #b0b0b0;
  font-size: 12px;
}

@keyframes feather_3 {
    0% { background-size: 120% 120%;}
    100% { background-size: 170% 170%;}
}

</style>
